import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Commonvariable } from 'src/app/commonvariable/commonvariable';
import { BillService } from 'src/app/_services/bill/bill.service';
import { CustomLoaderCComponent } from 'src/app/CustomLoader/custom-loader/custom-loader-c/custom-loader-c.component';
import { CommonConstants } from 'src/app/configuration/commonConstants';
import { DatePipe } from '@angular/common';
import { CommonService } from 'src/app/common/common.service';

@Component({
  selector: 'app-view-bill',
  templateUrl: './view-bill.component.html',
  styleUrls: ['./view-bill.component.css'],
  providers: [Commonvariable, CustomLoaderCComponent, DatePipe]
})

export class ViewBillComponent implements OnInit {
  @ViewChild('invoicetemplate') contentPDF: ElementRef;
  idBillmaster: string;
  
  public breadcrumb: any = {};
  public model: any = {}
  public listBillItems: any = [];
  public listPayment: any = [];
  public totalGSTAmount;
  public CGST: number;
  public totalPriceWithoutGST;
  public currency = this.Commonvariable.currency;
  public DateFormat : string = CommonConstants.DateFormatString
  public invoiceConfiguration: any = {};

  constructor(
    private router: ActivatedRoute,
    private spinner: CustomLoaderCComponent,
    private billService: BillService,
    private Commonvariable: Commonvariable,
    private datePipe : DatePipe,
    private CommonService: CommonService,
  ) {
    this.invoiceConfiguration = {
      invoiceAddress: this.CommonService.GetMasterDataByKey('InvoiceAddress') || 'Pune, Maharashtra 411014',
      invoiceEmail: this.CommonService.GetMasterDataByKey('InvoiceEmail') || 'default @gmail.com',
      invoiceContactNo: this.CommonService.GetMasterDataByKey('InvoiceContactNo') ||  '+91 1234567890',
      clientLogoUrl: this.CommonService.GetMasterDataByKey('ClientLogoUrl') ||  'assets/images/logo/logo.png',
    };    
   }

  ngOnInit() {

    this.spinner.showSpinner();
    this.idBillmaster = this.router.snapshot.queryParamMap.get('Id');
    this.idBillmaster = atob(this.idBillmaster);

    this.totalGSTAmount = 0
    this.totalPriceWithoutGST = 0;

    this.billService.GetBillById(Number(this.idBillmaster)).subscribe(Response => {
      this.model = Response;
      this.model.billDate = this.datePipe.transform(this.model.billDate, this.DateFormat);
      window.setTimeout(function () {

      }, 0);
      this.listBillItems = Response.listBillItems;
      this.listPayment = Response.listPayment;
      this.spinner.hideSpinner();
    });
  }
  
  getPrint(invoice) {
    const printContents = document.getElementById(invoice).innerHTML;
    const originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    document.title = this.model.customerFullName + "-" + this.model.displayBillNumber;
    window.print();
    document.body.innerHTML = originalContents;
    location.reload();
  }
}
